export default __webpack_public_path__ + "static/media/Kodchasan-Medium.ae05ddb5.ttf";